// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__29Sx3","productName":"Table_productName__3yniU"};